<template>
  <div id="roomtop" v-bind:class="{ page__room: true }">
    <div id="brand_banner" v-if="!!bannland">
      <img style="width:100%;height:3rem;object-fit:contain;"
        :src="bannland">
      </img>
    </div>
    <div class="wall_container">
      <div id="dial_controls" v-if="dial_show">
         <div> This host is forwarding you a phone. </div>
         <b-button size="sm"
           style="text-align:center"
           variant="danger"
           @click="dial_hangup"
           :disabled="dial_disable"
         >
           <div>HangUp</div>
           <div class="dial-status">{{dial_status}} {{dial_elapse}}</div>
         </b-button>
         <div>
           <input-sub class="dial_dtmf"
             ref="dtmf_input_box"
             v-model="dial_dtmf"
             v-on:enter='dial_send_dtmf'
             placeholder="Send keypad numbers..."
           >
           </input-sub>
           <b-button size="sm" class="dial_mute"
              :variant="dial_mute_variant"
              @click="dial_mute_toggle">
              {{dial_mute_text}}
           </b-button>
         </div>
      </div>
      <div id="room_wall">
      </div>
      <no-access ref="noaccess"
        :app="$parent"
        tgt="room"
        v-on:restart="startFresh"
        >
      </no-access>
    </div>
    <slide-out class="capture_slideout"
      :visible="$parent.show_panel"
      @open="onCapturePanelOpen"
      @close="onCapturePanelClose"
      size="50%"
    >
      <div slot="header" class="text-center">
          <b-button class="center" variant="link"
             v-if="$parent.amStreaming()"
             style="margin:0;padding: 0 1rem;color:black;border:1px solid #f08080;min-width:20%"
              @click="closePanel">
              close
          </b-button>
      </div>

      <div class="container cap-container controls mt-1" syle="position:relative;">
      <!--
        <b-row>
          <b-col md="3" v-if="$parent.mydevice.tupload_restart">
            <b-button @click="uploadRestart(0)" :variant="rest_var['audio']">
              Re-A
            </b-button>
          </b-col>
          <b-col md="3" v-if="$parent.mydevice.tupload_restart">
            <b-button @click="uploadRestart(1)" :variant="rest_var['video']">
              Re-V
            </b-button>
          </b-col>
          <b-col md="1" v-if="false && $parent.mydevice.tupload_stall">
            <b-button @click="uploadStall">
              St
            </b-button>
          </b-col>
        </b-row>
     -->

     <!--
        <b-row>
           <b-col md="12">
             <b-button-group class="thingroup" style="width:100%">
               <b-button class="mt-1 mb-0 thinbtn" style="width:33%"
                 :variant="audcap == 'script' ? 'vxon':'outline-secondary'"
                 :disabled="showStopCapture()"
                 @click="update_audcap('script')">
                   Script
                 </b-button>
               <b-button class="mt-1 mb-0 thinbtn" style="width:33%;"
                 :variant="audcap == 'worklet' ? 'vxon':'outline-secondary'"
                 :disabled="showStopCapture()"
                 @click="update_audcap('worklet')">
                   Worklet
                 </b-button>
               <b-button class="mt-1 mb-0 thinbtn" style="width:33%;"
                 :variant="audcap == 'mr' ? 'vxon':'outline-secondary'"
                 :disabled="showStopCapture()"
                 @click="update_audcap('mr')">
                   MediaRecorder
                 </b-button>
             </b-button-group>
           </b-col>
        </b-row>
     -->

        <b-row v-if="$parent.amStreaming() == 2">
           <b-col md="12">
              <div class="mt-2 mb-2" style="font-weight:bold;"> 
              Video / Audio controls are in the browser window where you
              started your capture.
              </div>
           </b-col>
        </b-row>

       <b-row class="mt-0" v-if="$parent.amStreaming() != 2">
          <b-col md="12" style="text-align:center">
            <b-button :variant="stop_prop.color" style="width:80%"
              v-show="showStopCapture()"
              @click="stopCapture">
                 {{ stop_prop.text }}
            </b-button>
          </b-col>
          <b-col md="12" style="">
            <div class="btn_start_area">
              <b-button variant="vxon" class="btn_start btn_watch"
                v-if="onlywatch && !$parent.avrefresh_in_progress && showStartCapture()"
                @click="closePanel">
                    Only Watch
              </b-button>
              <b-button variant="success" class="btn_start"
                v-if="!($parent.selected_video_source === null) && showStartCapture()"
                :disable="!dc_ready"
                @click="startCapture('presenter',true)">
                    Join with&nbsp;Video
              </b-button>
              <b-button variant="vxon" class="btn_start btn_watch"
                v-if="enablevid && !($parent.has_enumerated_video) && showStartCapture()"
                @click="turn_on_camera()">
                    Turn&nbsp;On Camera
              </b-button>
              <b-button variant="success" class="btn_start"
                v-if="!($parent.mydevice.has_audio_selection && $parent.selected_audio_source[0] === null) && showStartCapture()"
                :disabled="!dc_ready"
                @click="startCapture('presenter',false)">
                    Join Audio&nbsp;Only
              </b-button>
              <b-button variant="success" class="btn_start btn_enable_vid"
                v-if="!($parent.selected_video_source === null) && $parent.mydevice.capture_state == 'capturing' && !$parent.mydevice.vcapturing && $parent.mydevice.share_state == 'off'"
                @click="enableVideo()">
                   Enable Video
              </b-button>
            </div>
            <div class="enum_msg"
               v-if="$parent.avrefresh_in_progress && $parent.enumerate_video && !$parent.has_enumerated_video"
            >
              Searching for cameras ...
            </div>
            <div class="enum_msg"
               v-if="$parent.avrefresh_in_progress && $parent.enumerate_audio && !$parent.has_enumerated_audio"
            >
              Searching for microphones ...
            </div>
          </b-col>
          <b-col md="12" id="pvw_top"
            style="text-align:center;min-height:5rem;max-height:10rem;">
          </b-col>
        </b-row>

      <!--
        <b-row class="mt-0" v-if="$parent.amStreaming() != 2 && showStopCapture() && $parent.video_max == 3">
          <b-col md="3" style="text-align:center">
            <b-input
              v-model="pt_kbps_in"
              placeholder="Kbps">
            </b-input>
          </b-col>
          <b-col md="3" style="text-align:center">
            <b-button :disabled="pt_kbps == pt_kbps_in"
              v-model="pt_kbps_in"
              @click="set_pt_kbps()"
              placeholder="Kbps">
              Set Kbps
            </b-button>
          </b-col>
        </b-row>
      -->

      <div style="width:100%;text-align:center;">
        <b-link @click="advanced_av = !advanced_av"
          style="font-size: 0.7rem; text-transform:uppercase; text-decoration:underline;">
          Advanced Controls
        </b-link>
      </div>
      <b-collapse v-model="advanced_av">

        <div  v-if="$parent.amStreaming() != 2 && $parent.video_groups !== null && $parent.mydevice.share_state == 'off'" class="ctrlsec mt-1">
         <b-card no-body style="border:none">

             <b-button block href="#" class="m-0 p-1 highlight controls_head"
               v-if="$parent.video_groups.length > 0"
               v-b-toggle.vid-config
               variant="vxwhite">
               Configure Camera
             </b-button>
             <b-button block href="#" class="m-0 p-1 highlight controls_head"
               style="color:black"
               v-if="$parent.video_groups.length == 0"
               disabled
               variant="vxwhite">
               No Camera Detected
             </b-button>

           <b-collapse id="vid-config" accordion="my-accordion">

        <b-row>
          <b-col v-if="$parent.video_enabled && canFlip && !showStartCapture()" md="12">
           <b-button-group class="thingroup" style="width:100%">
              <b-button class="mt-1 mb-0 thinbtn"
                variant="vxon"
                @click="flipCamera">
                <i class="typcn typcn-arrow-sync-outline" style=""></i>
                Flip
              </b-button>
           </b-button-group>
          </b-col>
        </b-row>
        <b-row v-if="$parent.amStreaming() != 2">
          <b-col class="mt-1" v-if="$parent.video_enabled && $parent.video_groups" sm="5">
             <b-form-select v-model="$parent.selected_video_group"
                style="padding:0"
                :options="$parent.video_groups" size="sm"
                :select-size="3" :disabled=videoSelectionLocked()
                @change="$parent.onVideoGroupChange()">
             </b-form-select>
          </b-col>
          <b-col class="mt-1" v-if="$parent.video_enabled && $parent.video_sources" sm="7">
             <b-form-select v-model="$parent.selected_video_source"
                style="padding:0"
                :options="$parent.video_sources" size="sm"
                :select-size="3" :disabled=videoSelectionLocked()
                @change="onVideoSourceChange()">
             </b-form-select>
          </b-col>
        </b-row>

        <!--
        <b-row v-if="$parent.amStreaming() != 2 && showStartCapture()">
           <b-col v-if="$parent.video_groups" md="12">
             <b-button-group class="thingroup" style="width:100%">
               <b-button class="mt-1 mb-0 thinbtn" style="width:50%"
                 :variant="$parent.video_enabled ? 'vxon':'outline-secondary'"
                 @click="vidToggle">
                   Video Enabled
                 </b-button>
               <b-button class="mt-1 mb-0 thinbtn" style="width:50%;"
                 :variant="$parent.video_enabled ? 'outline-secondary':'vxon'"
                 @click="vidToggle">
                   Video Disabled
                 </b-button>
             </b-button-group>
           </b-col>
        </b-row>
        -->

        <!--
        <b-row v-if="$parent.amStreaming() != 2 && !$parent.mydevice.vcapturing">
           <b-col v-if="$parent.video_enabled && $parent.video_groups" md="12">
             <b-button-group class="thingroup" style="width:100%">
               <b-button v-if="$parent.mydevice.pt_can_send"
                 class="mt-1 mb-0 thinbtn" style="width:50%"
                 :variant="$parent.video_max == 3 ? 'vxon':'outline-secondary'"
                 @click="$parent.update_video_max(3)">
                   Video HD
                 </b-button>
               <b-button v-if="!$parent.mydevice.pt_can_send"
                 class="mt-1 mb-0 thinbtn" style="width:50%"
                 :variant="$parent.video_max == 2 ? 'vxon':'outline-secondary'"
                 @click="$parent.update_video_max(2)">
                   Video SD
                 </b-button>
               <b-button
                 class="mt-1 mb-0 thinbtn" style="width:50%;"
                 :variant="$parent.video_max == 1 ? 'vxon':'outline-secondary'"
                 @click="$parent.update_video_max(1)">
                   Video Low
                 </b-button>
             </b-button-group>
           </b-col>
        </b-row>
        -->

        <b-row v-if="$parent.mydevice.bgef.show && $parent.amStreaming() != 2 && $parent.video_enabled && $parent.selected_video_source">
           <b-col md="12">
             <div style="font-weight:bold;">
                {{ $parent.mydevice.bgef.msg }}
             </div>
             <b-button-group class="thingroup" style="width:100%">
               <b-button
                 class="mt-1 mb-0 thinbtn"
                 :variant="!$parent.mydevice.bgef.isel ? 'vxon':'outline-secondary'"
                 @click="update_bg_ef_off()">
                   Disabled
               </b-button>
               <b-button
                 class="mt-1 mb-0 thinbtn"
                 :variant="$parent.mydevice.bgef.isel ? 'vxon':'outline-secondary'"
                 @click="update_bg_ef_on()">
                   Image
               </b-button>
             </b-button-group>
           </b-col>
           <b-col md="12" v-if="$parent.mydevice.bgef.isel">
             <div
               style="text-align:center;">
               Choose Image File
             </div>
             <b-row>
               <b-col>
                  <upload-image
                    v-model="bg_selected_img"
                    v-on:changed="bgImageSelected"
                    v-on:loaderror="bgImageError"
                    imgkind="user_bg"
                    size=16
                    optional=true
                  />
               </b-col>
             </b-row>
           </b-col>
         </b-row>

           </b-collapse>
         </b-card>
        </div>

       <div  v-if="$parent.amStreaming() != 2 && $parent.audio_groups !== null" class="ctrlsec">
         <b-card no-body style="border:none">
             <b-button block href="#" class="m-0 p-1 highlight controls_head"
               v-b-toggle.aud-config
               variant="vxwhite">
               Configure Microphone
             </b-button>
           <b-collapse id="aud-config" accordion="my-accordion">

        <b-row v-if="$parent.mydevice.change_aud_src && $parent.amStreaming() == 1">
           <b-col v-if="$parent.is_mod" md="12">
             <b-button-group class="thingroup" style="width:100%">
               <b-button class="mt-1 mb-0 thinbtn" style="width:50%"
                 :variant="($parent.sel_audio_idx == 0) ? 'vxon':'outline-secondary'"
                 @click="config_audio(0)">
                   Primary Audio
                 </b-button>
               <b-button class="mt-1 mb-0 thinbtn" style="width:50%;"
                 :variant="($parent.sel_audio_idx == 1) ? 'vxon':'outline-secondary'"
                 @click="config_audio(1)">
                   Background Audio
                 </b-button>
             </b-button-group>
           </b-col>
        </b-row>
        <b-row v-if="$parent.mydevice.change_aud_src && $parent.amStreaming() != 2">
           <b-col class="mt-1" v-if="$parent.audio_groups" sm="5">
             <b-form-select v-model="$parent.selected_audio_group[$parent.sel_audio_idx]"
                style="padding:0"
                :options="$parent.audio_groups" size="sm"
                :select-size="3" :disabled=audioSelectionLocked()
                @change="onAudioGroupChange()">
             </b-form-select>
          </b-col>
          <b-col class="mt-1" v-if="$parent.audio_sources" sm="7">
            <b-form-select v-model="$parent.selected_audio_source[$parent.sel_audio_idx]"
                style="padding:0"
                :options="$parent.audio_sources" size="sm"
                :select-size="3" :disabled=audioSelectionLocked()
                @change="onAudioSourceChange()">
             </b-form-select>
          </b-col>
        </b-row>
        <b-row v-if="$parent.amStreaming() != 2 && showStartCapture()">
           <b-col v-if="$parent.mydevice.has_audio_ns" md="12">
             <b-button-group class="thingroup" style="width:100%">
               <b-button class="mt-1 mb-0 thinbtn" style="width:50%"
                 :disabled="audioSelectionLocked()"
                 :variant="nsdb ? 'vxon':'outline-secondary'"
                 @click="nsdb = 21, userarate = 48">
                   Noise Suppression
                 </b-button>
               <b-button class="mt-1 mb-0 thinbtn" style="width:50%"
                 :disabled="audioSelectionLocked()"
                 :variant="nsdb ? 'outline-secondary':'vxon'"
                 @click="nsdb = 0, userarate = 64">
                   Unfiltered Audio
                 </b-button>
             </b-button-group>
           </b-col>
        </b-row>
        <b-row v-if="showStartCapture()">
          <b-col md="12" v-if="showarate()">
            <b-button-group class="thingroup" style="width:100%">
            <b-button class="mt-1 mb-0 thinbtn" style="width:50%;"
              :disabled="audioSelectionLocked()"
              :variant="userarate == 48 ? 'vxon':'outline-secondary'"
              @click="userarate = 48">
                Speech Quality
            </b-button>
            <b-button class="mt-1 mb-0 thinbtn" style="width:50%;"
              :disabled="audioSelectionLocked()"
              :variant="userarate == 128 ? 'vxon':'outline-secondary'"
              @click="userarate = 128">
                Music Quality
            </b-button>
            </b-button-group>
          </b-col>
        </b-row>

           </b-collapse>
         </b-card>
        </div>

        <div class="ctrlsec">
          <b-card no-body style="border:none">
             <b-button block href="#" class="m-0 p-1 highlight controls_head"
               v-b-toggle.spk-config
               variant="vxwhite">
               Configure Speaker
             </b-button>
             <b-collapse id="spk-config" accordion="my-accordion">
              <b-row>
               <b-col class="mt-1" v-if="$parent.enable_speaker_select && $parent.speaker_sources" sm="12">
                 <b-form-select v-model="$parent.selected_speaker_source"
                    style="padding:0"
                    :options="$parent.speaker_sources" size="sm"
                    :select-size="3"
                    @change="onSpeakerSourceChange()">
                 </b-form-select>
               </b-col>
               <b-col md="12">
                 Output Volume Boost: {{ audio_gain }}x
                 <vue-slider style="margin: 0 0.5rem;"
                   v-model="audio_gain" @change="change_audio_gain()"
                   :data="ag_values"
                   :tooltip="'none'"
                 ></vue-slider>
               </b-col>
              </b-row>
          <!-- iOS APP ONLY
              <b-row>
                <b-col md="12" v-if="showSpeakerMode">
                  <b-button-group class="thingroup" style="width:100%">
                    <b-button
                      class="mt-1 mb-0 thinbtn" style="width:50%"
                      :variant="$parent.mydevice.speaker_src ? 'vxon':'outline-secondary'"
                      @click="toggleSpeakerSrc">
                      Speaker
                    </b-button>
                    <b-button
                      class="mt-1 mb-0 thinbtn" style="width:50%"
                      :variant="$parent.mydevice.speaker_src ? 'outline-secondary':'vxon'"
                      @click="toggleSpeakerSrc">
                      Earbud
                    </b-button>
                  </b-button-group>
                </b-col>
              </b-row>
           -->
             </b-collapse>
          </b-card>
        </div>

        <b-row>
           <b-col v-if="insideMyRoom()" md="12">
             <b-button-group class="thingroup" style="width:100%">
               <b-button class="mt-1 mb-0 thinbtn" style="width:50%"
                 :variant="is_on_home ? 'vxon':'outline-secondary'"
                 @click="setShowOnHome(true)">
                   Room on Home
                 </b-button>
               <b-button class="mt-1 mb-0 thinbtn" style="width:50%;"
                 :variant="is_on_home ? 'outline-secondary':'vxon'"
                 @click="setShowOnHome(false)">
                   Room Not Visible
                 </b-button>
             </b-button-group>
           </b-col>
        </b-row>
    </b-collapse>

        <b-row class="">
          <b-col md="10">
            <b-progress height="5px" class="mt-2" :max="128"
              v-show="showStopCapture()" >
              <b-progress-bar :value="audio_activity1" variant="success"></b-progress-bar>
              <b-progress-bar :value="audio_activity2" variant="warning"></b-progress-bar>
              <b-progress-bar :value="audio_activity3" variant="danger"></b-progress-bar>
            </b-progress>
          </b-col>
        </b-row>

        <b-row class="mt-3" v-if="$parent.amStreaming() != 2">
          <b-col md="11">
            <b-button variant="secondary"
              v-if="!cap_tn"
              v-show="showPreview()"
              @click="grabThumbnail()">
                  Grab Thumbnail
            </b-button>
            <b-button variant="success"
              v-if="cap_tn"
              @click="keepThumbnail()">
                  Keep
            </b-button>
            <b-button variant="danger"
              v-if="cap_tn"
              @click="discardThumbnail()">
                  Discard
            </b-button>
          </b-col>
       <!--
          <b-col md="5" v-show="showPreview()">
            Video Preview
            <canvas id="pvw_self" style="width:90%;"></canvas>
          </b-col>
          <b-col md="5">
            Your Thumbnail
            <div id="pvw_tn"></div>
          </b-col>
       -->
        </b-row>

        <b-row v-if="false && showStopCapture()">
          <b-col md="12">
               Video Rate Control
               <b-table
                 show-empty small
                 stacked="sm"
                 :fields="streams_rcFields"
                 :items="streams_rc"
                 small
                 style="font-size:0.75rem"
                 empty-text="No video streams"
               >
                 <template v-slot:cell(crf)="data">
                   <b-input style="padding:0 0.5rem;height:auto;" v-model="data.item.crf"> </b-input>
                 </template>
                 <template v-slot:cell(maxrate)="data">
                   <b-input style="padding:0 0.5rem;height:auto;" v-model="data.item.maxrate"> </b-input>
                 </template>
                 <template v-slot:cell(bufsize)="data">
                   <b-input style="padding:0 0.5rem;height:auto;" v-model="data.item.bufsize"> </b-input>
                 </template>
                 <template v-slot:cell(maxcrf)="data">
                   <b-input style="padding:0 0.5rem;height:auto;" v-model="data.item.maxcrf"> </b-input>
                 </template>
               </b-table>
          </b-col>
        </b-row>

        <b-row v-if="false && streams_rc[0] && showStopCapture()">
          <b-col md="12">
           <b-button @click="update_video_rc"
             variant="primary">
             Update Video RC
           </b-button>
          </b-col>
        </b-row>
        <b-row v-if="false">
          <b-col>
            <b-form-checkbox v-model="vpbypass"
                value="true" unchecked-value="false">
                Bypass Audio Processing
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="false">
          <b-col><hr></b-col>
          skip threshold
          <b-col><hr></b-col>
          <b-col md="4">
            <b-input size="sm" class="mb-1" :disabled=videoSelectionLocked()
              placeholder="seconds"
              v-model= "skipthresh"
             ></b-input>
          </b-col>
        </b-row>
        <b-row v-if="false">
          <b-col><hr></b-col>
          sendbuf
          <b-col><hr></b-col>
          <b-col md="4">
            <b-input size="sm" class="mb-1" :disabled=videoSelectionLocked()
              placeholder="kb"
              v-model= "curlsend"
             ></b-input>
          </b-col>
        </b-row>

      <div style="position:absolute;top:0;left:0;right:0;z-index:10;">
        <b-toaster name="mytoast" style="float:right;">
        </b-toaster>
      </div>


      </div>      
    </slide-out>
    
    <b-modal id="bv-wait-prompt" size="sm" hide-header hide-footer no-close-on-backdrop>
       <div v-if="prompt.state == 'main'">
          <b-row>
            <b-col class="prompt_head">
              <span class="prompt_head_txt">
                How would you like to reach out?
              </span>
            </b-col>
          </b-row>
          <b-row v-if="prompt_cfg.nameq_enabled">
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="prompt_state_step('byname')">
                By Person's Name
              </b-button>
            </b-col>
          </b-row>
          <b-row v-if="prompt_cfg.cat_enabled">
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="prompt_state_step('bycat')">
                By Department
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="prompt_state_step('nextavail')">
                Wait for Next Available Person
              </b-button>
            </b-col>
          </b-row>
          <b-row  v-if="prompt_cfg.callb_enabled">
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="prompt_state_step('callback')">
                Request a Call-Back
              </b-button>
            </b-col>
          </b-row>
       </div>

       <div v-if="prompt.state == 'nextavail-waited'">
          <b-row>
            <b-col class="prompt_head">
              <span class="prompt_head_txt">
                No one is available yet to talk with you. What would you like to do?
              </span>
            </b-col>
          </b-row>
          <b-row v-if="prompt_cfg.can_msg">
            <b-col>
              <b-button size="sm" variant="outline-danger"
                class="prompt_btn"
                @click="prompt_state_step('leavemsg')">
                Leave a Message
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="prompt_state_step('nextavail')">
                Continue Waiting
              </b-button>
            </b-col>
          </b-row>
          <b-row v-if="prompt_cfg.is_joined && (prompt_cfg.nameq_enabled || prompt_cfg.cat_enabled || prompt_cfg.callb_enabled)">
            <b-col>
              <div class="prompt_btn_mainlink"
                @click="prompt_state_step('main')">
                <span class="prompt_btn_mainback">
                  arrow_back_ios
                </span>
                <span class="prompt_btn_main">
                  Main Menu
                </span>
              </div>
            </b-col>
          </b-row>
       </div>

       <div v-if="prompt.state == 'byname'">
          <b-row>
            <b-col v-if="prompt.match_cnt < 0"
              class="prompt_head">
              <span class="prompt_head_txt">
                Type the name of the person you wish to reach. Hit enter when you are done.
              </span>
            </b-col>
            <b-col v-if="prompt.match_cnt == 0"
              class="prompt_head">
              <span class="prompt_head_txt">
                We were unable to find anyone named
              </span>
              <span class="prompt_name_txt">
                {{ prompt.prev_nameq }}
              </span>
              <span class="prompt_head_txt">
                . Please try again with a revised name.
              </span>
            </b-col>
            <b-col v-if="prompt.match_cnt > 3"
              class="prompt_head">
              <span class="prompt_name_txt">
                {{ prompt.prev_nameq }}
              </span>
              <span class="prompt_head_txt">
                matched too many people. Please try again with a more specific name.
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <input-sub
                v-model="prompt.nameq"
                v-on:enter="send_arrival_byname"
                placeholder="First and/or Last name">
              </input-sub>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="prompt_btn_mainlink"
                @click="prompt_state_step('main')">
                <span class="prompt_btn_mainback">
                  arrow_back_ios
                </span>
                <span class="prompt_btn_main">
                  Main Menu
                </span>
              </div>
            </b-col>
          </b-row>
       </div>

       <div v-if="prompt.state == 'byname-waited'">
          <b-row>
            <b-col class="prompt_head">
              <span class="prompt_name_txt">
                {{ prompt.prev_nameq }}
              </span>
              <span class="prompt_head_txt">
                has not responded
              </span>
            </b-col>
          </b-row>
          <b-row v-if="prompt_cfg.can_msg">
            <b-col>
              <b-button size="sm" variant="outline-danger"
                class="prompt_btn"
                @click="prompt_state_step('leavemsg')">
                Leave a Message
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="send_arrival_byname">
                Continue Waiting
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="prompt_btn_mainlink"
                @click="prompt_state_step('main')">
                <span class="prompt_btn_mainback">
                  arrow_back_ios
                </span>
                <span class="prompt_btn_main">
                  Main Menu
                </span>
              </div>
            </b-col>
          </b-row>
       </div>

       <div v-if="prompt.state == 'bycat'">
          <b-row>
            <b-col class="prompt_head">
              <span class="prompt_head_txt">
                Select the department you wish to reach
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" style="text-align:center;"
              v-for="cat in prompt_cfg.cats">
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                style="width:100%;"
                @click='send_arrival_bycat(null,cat)'>
               {{ cat.label }}
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="prompt_btn_mainlink"
                @click="prompt_state_step('main')">
                <span class="prompt_btn_mainback">
                  arrow_back_ios
                </span>
                <span class="prompt_btn_main">
                  Main Menu
                </span>
              </div>
            </b-col>
          </b-row>
       </div>

       <div v-if="prompt.state == 'bycat-waited'">
          <b-row>
            <b-col class="prompt_head">
              <span class="prompt_head_txt">
                No one from the
              </span>
              <span class="prompt_name_txt">
                {{ prompt.cat.label }}
              </span>
              <span class="prompt_head_txt">
                department is available yet
              </span>
            </b-col>
          </b-row>
          <b-row v-if="prompt_cfg.can_msg">
            <b-col>
              <b-button size="sm" variant="outline-danger"
                class="prompt_btn"
                @click="prompt_state_step('leavemsg')">
                Leave a Message
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button size="sm" variant="outline-primary"
                class="prompt_btn"
                @click="send_arrival_bycat">
                Continue Waiting
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="prompt_btn_mainlink"
                @click="prompt_state_step('main')">
                <span class="prompt_btn_mainback">
                  arrow_back_ios
                </span>
                <span class="prompt_btn_main">
                  Main Menu
                </span>
              </div>
            </b-col>
          </b-row>
       </div>

       <div v-if="prompt.state == 'callback'">
          <b-row>
            <b-col
              class="prompt_head">
              <span class="prompt_name_txt">
                {{ prompt.callback_name }}
              </span>
              <span class="prompt_head_txt">
                Once it is your turn to talk we will
                send you a link that brings you directly
                to an agent. You will retain your place in line.
              </span>
              <div class="prompt_head_txt" style="margin-top: 0.5rem;">
                Enter an email and/or phone number below where you
                wish to receive this link.
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" v-if="!prompt.callback_email_valid"
               style="font-size:0.8rem; color:red;">
               Invalid email
            </b-col>
            <b-col>
              <input-sub
                :init="prompt.callback_email"
                v-on:input="callback_email_input"
                placeholder="Email">
              </input-sub>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" v-if="!prompt.callback_phone_valid"
               style="font-size:0.8rem; color:red;">
               Invalid phone number
            </b-col>
            <b-col>
              <input-sub
                :init="prompt.callback_phone"
                v-on:input="callback_phone_input"
                placeholder="SMS Phone Number">
              </input-sub>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button size="sm" variant="outline-danger"
                class="prompt_btn"
                :disabled="!prompt.callback_valid"
                @click="prompt_state_step('callback-sub')">
                Request Callback and Exit
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="prompt_btn_mainlink"
                @click="prompt_state_step('main')">
                <span class="prompt_btn_mainback">
                  arrow_back_ios
                </span>
                <span class="prompt_btn_main">
                  Main Menu
                </span>
              </div>
            </b-col>
          </b-row>
       </div>

       <div v-if="prompt.state == 'callback-sub'">
          <b-row>
            <b-col
              class="prompt_head">
              <span class="prompt_name_txt">
                {{ prompt.callback_name }}
              </span>
              <span class="prompt_head_txt">
                Thank you!
              </span>
              <div class="prompt_head_txt" style="margin-top: 0.5rem;">
                You will receive a message when an agent is available. The message will include a link that brings you directly to the agent.
              </div>
              <div class="prompt_head_txt" style="margin-top: 0.5rem;">
                You may close the window.
              </div>
            </b-col>
          </b-row>
       </div>

    </b-modal>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import VueSlider from "vue-slider-component";
import UploadImage from "../components/UploadImage";
import NoAccess from "../components/NoAccess";
import sig from "../sigwire";
import InputSub from "../components/InputSub";
import RoomCore from "../room";

export default {
  name: "room",
  props: ["acc","uid"],
  components: {VueSlider,UploadImage,InputSub,NoAccess},
  watch: {
    $route(to, from) {
      // eslint-disable-next-line
      if (vx && vx.debug) { console.log("rwatch:" + from.params.uid + " " + to.params.uid); }
      this.$parent.set_room_background();
      window.vx_set_room(window.vx, to.params.acc, to.params.uid);
      this.check_room_mode(to.name);
      this.reset_prompt();
      this.startFresh();
      this.last_open = {acc: window.vx.room.acc, name: window.vx.room.name};
      vxslog({p:"room",a:"open"});
    },
    '$parent.mydevice.is_capturing': function(to, from) {
      let vue = this;
      /* If a new window is opened (or refresh) occurs while streaming
         then the window exits refreshAVSources without enumerating (a
         good thing). However, when capturing stops in the other window
         this one needs to do that initial enumeration. */
      if (to === false && vue.$parent.audio_groups === null &&
          vue.$parent.video_groups === null) {
          vue.$parent.refreshAVSources({notify:vue.notify});
      }
    },
    '$parent.mydevice.capture_state': function(to, from) {
       let vue = this;
       // eslint-disable-next-line
       if (vx && vx.debug) { console.log("CHANGED:"+JSON.stringify(from)+" => "+JSON.stringify(to)); }
       if (from != "capturing" && to == "capturing") {
          if (window.vx && window.vx.room) {
             window.vx.room.auto_join = true;
             if (vue.$router.from_bcast) {
               window.vx.room.auto_raise = true;
               vue.$parent.show_notification("Once your stream is ready you will be placed in line to ask a question.", {variant: "info"});
             } else {
               if (vx.room.can_join) {
                 vue.$parent.show_notification("You will automatically enter the room once your connection is established.", {variant: "info"});
               } else if (vx.room.can_view) {
                 vue.$parent.show_notification("You started streaming but do not have permission to participate. You can continue to watch.");
               }
               setTimeout(function() {
                  vue.$parent.hidePanel();
               }, 200);
             }
          }
       } else if (from != "off" && to == "off") {
         if (!vue.noaccess_showing() && vue.prompt.state != "callback-sub") {
           setTimeout(function() {
              vue.$parent.showPanel();
           },200);
         }
         window.vx_vid_erase();
       }
       vue.updateStopColor(to);
    },
    nsdb: function(to, from) {
       this.$parent.mydevice.set_audio_ns({level: to});
    }
  },
  created: function() {
    //console.log("room created");
  },
  updated: function() {
  },
  data() {
    return {
      dc_ready: false,
      userarate: 48,
      audcap: 'mr',
      capturePanelIsOpen: false,
      captureDC: "",
      onlywatch: true,
      enablevid: true,
      is_on_home: false,
      canFlip: this.$parent.mydevice.can_flip,
      showRefreshAV: this.$parent.mydevice.show_refresh,
      showSpeakerMode: (this.$parent.mydevice.swap_speaker_src)?true:false,
      //speakerSrc: this.$parent.mydevice.speaker_src,
      annotationMode: 0,
      micState: {
        caption: "Mic Off",
        state: false
      },
      stop_prop: {color:"warning", text:"...pending"},
      vpbypass: "false",
      audio_activity1: 0,
      audio_activity2: 0,
      audio_activity3: 0,
      bskipon:0,
      curlsend:8,
      skipthresh:"0.4",
      cap_tn:null,
      audio_gain: 1,
      ag_values: [ 0.2, 0.5, 1, 2, 3, 4, 5, 10, 15, 20, 25, 30, 40, 50, 60, 70, 80, 90, 100 ],
      nsdb: 21,
      video_fct_values: [ 1, 2, 3 ],
      video_fct: 2,
      bg_selected_img: "",
      pt_kbps_in: 0,
      pt_kbps: 0,
      streams_rc: [],
      streams_rcFields:[
        { key: "t", label: "Type" },
        { key: "crf", label: "crf" },
        { key: "maxrate", label: "maxrate" },
        { key: "bufsize", label: "bufsize" },
        { key: "maxcrf", label: "maxcrf" },
      ],
      rest_var: {"video":"danger", "audio":"danger"},
      dial_show: false,
      dial_disable: false,
      dial_status: "",
      dial_elapse: "",
      dial_dtmf: "",
      dial_muted: false,
      dial_mute_text: "Mute Call",
      dial_mute_variant: "outline-secondary",
      advanced_av: false,

      prompt_cfg: {
        /* Entire prompt/arrival feature */
        enabled: false,
        repeat_ms: 0,
        /* Can send arrival notifications */
        arrival_enabled: false,
        /* Allow filter by name */
        nameq_enabled: false,
        /* Allow filter by category/department */
        cat_enabled: false,
        /* Callback enabled */
        callb_enabled: false,
        cats: [],
        is_alone: false,
        is_joined: false,
        can_msg: false,
      },
      prompt: {
        /* Current step in state machine */
        state: "",
        match_cnt: -1,
        nameq: "",
        prev_nameq: "",
        cat: "",
        callback_email: "",
        callback_email_valid: false,
        callback_phone: "",
        callback_phone_valid: false,
        callback_valid: false,
      },
      bannland: "",
      transcribe: {
        open: false,
        para0: "",
        para1: "",
        para2: "",
      }
    };
  },
  computed: {
    isMod: function() {
      return this.$parent.vx;
    },
    isTest: function() {
      return true;
    },
  },
  methods: {
    notify: function(k,m,opt={}) {
      let vue = this;
      let variant="success";
      let delay = 5000;
      if (k == 'err') {
         variant="danger";
         delay = 20000;
      }
      let x = m;
      if (opt.url) {
        x = this.$createElement('div',{}, [
          this.$createElement('span',{
            style:'font-weight:bold;',
          }, m),
          this.$createElement('a',{
            style:'font-weight:bold;margin:0 0.5rem;',
            domProps:{href:opt.url,target:"_blank"}},
            (opt.urlText || "Link")),
         ]
        );
      }
      this.$bvToast.toast([
           this.$createElement('div',{style:'display:none'})
        ], {
        title: x,
        variant: variant,
        autoHideDelay: delay,
        appendToast: true,
        toaster: "mytoast",
      });
    },
    startFresh: function() {
      this.$bvModal.hide('bv-wait-prompt');
      if (!this.room || !this.room.startFresh) { return; }
      this.room.startFresh(this.trigger_cb);
      window.updateUserState = this.room.updateUserState;
    },
    change_audio_gain: function() {
      let vue = this;
      let ag = 0.0+vue.audio_gain;
      vue.$parent.mydevice.set_audio_gain(ag);
      if (vx) {
         vx.volume = ag;
         if (vx.sw) { vx.sw.setVolume(vx.volume); }
      }
    },
    closePanel() {
      let vue = this;
      vue.allow_close = true;
      vue.$parent.hidePanelManual();
    },
    hasBridge() {
      return this.$parent.mydevice.has_bridge;
    },
    toggleSpeakerSrc: function() {
      let vue = this;
      vue.$parent.mydevice.swap_speaker_src();
      vue.audio_gain = vue.$parent.mydevice.get_audio_gain() || 1;
      vue.change_audio_gain();
    },
    updateStopColor(to) {
      let vue = this;
      if (to == "capturing") {
        vue.stop_prop.color = "danger";
        vue.stop_prop.text = "stop";
      } else {
        vue.stop_prop.color = "warning";
        vue.stop_prop.text = "pending";
      }
    },
    setBackground() {
      return this.$parent.mydevice.set_background;
    },
    hasRoom: function() {
      return (
        this.$parent.currentUser.nick &&
        this.$parent.currentUser.nick != "" &&
        this.$parent.currentUser.nick != "-please-set-"
      );
    },
    insideMyRoom: function() {
      if (!this.hasRoom()) { return false; }
      return (
        this.$parent.viewTitle == "Room" &&
        this.$parent.currentUser.nick == this.uid
      );
    },
    turn_on_camera: function() {
      let vue = this;
      vue.$parent.enableVideoEnum(function() {
        vue.$parent.refreshAVSources({notify:vue.notify});
      });
    },
    noaccess_showing: function() {
      if (this.$refs.noaccess) {
        return this.$refs.noaccess.is_showing();
      }
      return false;
    },
    trigger_cb: function(name, opt) {
      if (name == "noaccess") {
        if (this.$refs.noaccess) {
          this.$refs.noaccess.trigger_noaccess(opt);
        }
      } else if (name == "dial") {
        this.trigger_dial(opt);
      } else if (name == "bgimg") {
        this.$parent.set_room_background(opt.url);
      } else if (name == "bannland") {
        this.bannland = opt.url;
      } else if (name == "config_notify") {
        opt.prompt_enabled = true;
        this.setup_prompt(opt);
      } else if (name == "config_presence") {
        this.setup_prompt(opt);
      } else {
        logger.warn("Unknown cb name:"+name);
      }
    },
    reset_prompt: function() {
      let vue = this;
      window.clearTimeout(vue.prompt.tid);
      delete vue.prompt.tid;
      vue.prompt.state = "";
      vue.prompt.nameq = "";
      vue.prompt.prev_nameq = "";
      vue.prompt.cat = "";
      vue.prompt.match_cnt = -1;
      vue.prompt.callback_email = "";
      vue.prompt.callback_email_valid = false;
      vue.prompt.callback_phone = "";
      vue.prompt.callback_phone_valid = false;
      vue.prompt.callback_valid = false;

      delete vue.prompt_cfg.message_cb;
      vue.prompt_cfg.enabled = false;
      vue.prompt_cfg.prompt_ms = 0;
      vue.prompt_cfg.arrival_enabled = false;
      vue.prompt_cfg.nameq_enabled = false;
      vue.prompt_cfg.cat_enabled = false;
      vue.prompt_cfg.callb_enabled = false;
      vue.prompt_cfg.cats = [];
      vue.prompt_cfg.is_alone = false;
      vue.prompt_cfg.is_joined = false;
      vue.prompt_cfg.is_detached = false;
      vue.prompt_cfg.can_msg = false;
    },
    set_if_changed(cfg, field, val) {
      if (val === undefined) { return false; }
      if (cfg[field] === val) { return false; }
      cfg[field] = val;
      return true;
    },
    setup_prompt: function(opt) {
      let vue = this;
      let changed = false;
      if (vue.$parent.is_mod) { return; }

      changed |= vue.set_if_changed(vue.prompt_cfg, "enabled",
                                    opt.prompt_enabled);
      if (opt.prompt_sec !== undefined) {
        let ms = 1000*(opt.prompt_sec||0);
        changed |= vue.set_if_changed(vue.prompt_cfg, "repeat_ms", ms);
      }
      changed |= vue.set_if_changed(vue.prompt_cfg, "arrival_enabled",
                                opt.arrival_enabled);
      changed |= vue.set_if_changed(vue.prompt_cfg, "nameq_enabled",
                                opt.nameq_enabled);
      changed |= vue.set_if_changed(vue.prompt_cfg, "cat_enabled",
                                opt.cat_enabled);
      changed |= vue.set_if_changed(vue.prompt_cfg, "callb_enabled",
                                opt.callb_enabled);
      if (opt.cats !== undefined) {
         vue.prompt_cfg.cats = opt.cats;
      }
      changed |= vue.set_if_changed(vue.prompt_cfg, "is_alone",
                                opt.is_alone);
      changed |= vue.set_if_changed(vue.prompt_cfg, "is_joined",
                                opt.is_joined);
      changed |= vue.set_if_changed(vue.prompt_cfg, "is_detached",
                                opt.is_detached);
      changed |= vue.set_if_changed(vue.prompt_cfg, "can_msg",
                                opt.can_msg);
      if (opt.message_cb) {
        vue.prompt_cfg.message_cb = opt.message_cb;
      }
      if (!changed) { return; }
      if (vx && vx.debug) { console.log("SETUP PROMPT",changed,JSON.stringify(vue.prompt_cfg),opt.can_msg); }

      vue.prompt_clr_timer();
      if (vue.prompt_cfg.is_detached) {
        return;
      }
      if (!vue.prompt_cfg.enabled || !vue.prompt_cfg.is_alone ||
           vue.noaccess_showing()) {
        vue.$bvModal.hide('bv-wait-prompt');
        return;
      }

      /* Config important to state machine changed. */
      vue.prompt.state = "";
      vue.prompt.callback_name = vx_user_dname(vue.$parent.currentUser.first_name,vue.$parent.currentUser.last_name,vue.$parent.currentUser.email);
      vue.callback_email_input(vue.$parent.currentUser.email);
      vue.callback_phone_input("");
      delete vue.prompt.single_room;
      if (vue.prompt_cfg.is_joined &&
          (vue.prompt_cfg.nameq_enabled || vue.prompt_cfg.cat_enabled ||
           vue.prompt_cfg.callb_enabled)) {
        vue.prompt_state_step("main");
      } else {
        vue.prompt_state_step("nextavail");
      }
    },
    prompt_clr_timer: function() {
      let vue = this;
      window.clearTimeout(vue.prompt.tid);
      delete vue.prompt.tid;
    },
    prompt_set_timer: function() {
      let vue = this;
      if (vue.prompt_cfg.repeat_ms < 5000) {
        vue.prompt_cfg.repeat_ms = 30000;
      }
      window.clearTimeout(vue.prompt.tid);
      vue.prompt.tid = setTimeout(function(){
        vue.prompt_timer_fired();
      }, vue.prompt_cfg.repeat_ms);
    },
    prompt_state_step: function(state) {
      let vue = this;
      if (vx && vx.debug) { console.log("PROMPT_STATE_STEP",state); }
      switch(state) {
      case "main":
        vue.prompt.match_cnt = -1;
        vue.prompt.state = state;
        delete vue.prompt.single_room;
        window.clearTimeout(vue.arrival_tid);
        delete vue.arrival_state;
        vue.$bvModal.show('bv-wait-prompt');
        break;
      case "byname":
      case "byname-waited":
        vue.prompt.state = state;
        vue.$bvModal.show('bv-wait-prompt'); 
        break;
      case "bycat":
      case "bycat-waited":
        vue.prompt.state = state;
        vue.$bvModal.show('bv-wait-prompt');
        break;
      case "nextavail":
        vue.prompt.match_cnt = -1;
        vue.prompt.state = state;
        vue.$bvModal.hide('bv-wait-prompt');
        if (vue.prompt_cfg.is_joined && vue.prompt_cfg.arrival_enabled) {
          vue.send_arrival({},function() {
            /* Do not leave messages in single-match room to 'all' */
            delete vue.prompt.single_room;
          });
        }
        vue.prompt_set_timer();
        break;
      case "nextavail-waited":
        /* If the only option in the menu is going to be "continue to wait" then
         *   assume this will be selected and don't both prompting the user */
        vue.prompt.state = state;
        vue.$bvModal.show('bv-wait-prompt');
        break;
      case "leavemsg":
        vue.$bvModal.hide('bv-wait-prompt');
        if (vue.prompt.single_room) {
          /* Go to matched room to leave message instead of
             leaving message here */
          vue.$router.push({name:"room",
                            params:{uid:vue.prompt.single_room}});
          break;
        }
        vue.prompt.state = "leavemsg"
        if (vue.prompt_cfg.message_cb && vue.prompt_cfg.can_msg) {
           vue.prompt_cfg.message_cb();
        }
        break;
      case "callback":
        vue.prompt.state = state;
        vue.$bvModal.show('bv-wait-prompt');
        break;
      case "callback-sub":
        /* To avoid double-clicking submit */
        vue.prompt.callback_valid = false;
        wss_send_cb(vx, "exit_room", {
          detach: {
             em: vue.prompt.callback_email,
             ph: vue.prompt.callback_phone,
          }
        }, function(msg) {
          /* Force a stop capture */
          vue.$parent.exit_listener = null;
          vue.$parent.mydevice.capture_state = "unknown";
          vue.$parent.sel_audio_idx = 0;
          vue.$parent.mydevice.stop_capture({}, function(err,data) {
             vue.prompt.state = state;
             vue.$bvModal.show('bv-wait-prompt');
          });
        });
        vue.send_arrival({},function() {
          /* Do not leave messages in single-match room to 'all' */
          delete vue.prompt.single_room;
        });
        break;
      default:
        vue.$bvModal.hide('bv-wait-prompt');
      }      
    },
    prompt_timer_fired: function() {
      let vue = this;
      if (vue.prompt.state == "byname" ||
          vue.prompt.state == "byname-waited") {
        vue.prompt_state_step("byname-waited");
      } else if (vue.prompt.state == "bycat" ||
                 vue.prompt.state == "bycat-waited") {
        vue.prompt_state_step("bycat-waited");
      } else if (vue.prompt.state == "nextavail" ||
                 vue.prompt.state == "nextavail-waited") {
        vue.prompt_state_step("nextavail-waited");
      }
    },
    send_arrival_byname: function() {
      let vue = this;
      vue.prompt.prev_nameq = vue.prompt.nameq;
      vue.$bvModal.hide('bv-wait-prompt');

      vue.send_arrival({nameq: ""+vue.prompt.nameq, max:3}, function() {
        /* Callback does NOT mean arrivals have finished. Only
           that we have basic info */
        if (!vue.prompt.match_cnt) {
          /* No matches */
          vue.prompt_state_step("byname");
        } else if (vue.prompt.match_cnt > 3) {
          /* To many matches */
          vue.prompt_state_step("byname");
        } else {
          vue.prompt_set_timer();
          vue.$parent.show_notification(`${vue.prompt.nameq} has been notified you that are waiting.`, {delay:5000, variant: "info"});
        }
      });
    },
    send_arrival_bycat: function(ev,cat) {
      let vue = this;
      if (cat) { vue.prompt.cat = cat; }
      vue.$bvModal.hide('bv-wait-prompt');
      if (vue.prompt.cat.cat.indexOf("@") == 0) {
         /* Transfer to Room */
         let acc = ""+vue.$router.currentRoute.params.acc;
         let room = ""+vue.prompt.cat.cat.replace("@","");
         /* Setup room so that auto_join can be set */
         vx_set_room(vx, acc, room);
         vx.room.auto_join = true;
         vue.$router.push({name:"room", params:{uid:room}});
      } else {
        vue.prompt_set_timer();
        vue.send_arrival({cat: ""+vue.prompt.cat.cat}, function() {
          /* Callback does NOT mean arrivals have finished. Only
             that we have basic info */
          //if (!vue.prompt.match_cnt) {
          //   FIXME: handle no matches to category?
          //} else {
            /* Do not leave messages in single-match room */
            delete vue.prompt.single_room;
            vue.$parent.show_notification(`The ${vue.prompt.cat.label} department has been notified that you are waiting.`, {delay:5000, variant: "info"});
          //}
        });
      }
    },
    send_arrival: function(opt, cb) {
      let vue = this;
      if (vue.arrival_state) {
         /* If someone has chosen to continue to wait, don't
            interrupt any still in-progress arrival notifications */
         console.log("Send Arrival in Progress",
                     JSON.stringify(vue.arrival_state));
         return;
      }
      vue.arrival_state = {};
      vue.arrival_state.nameq = opt.nameq;
      vue.arrival_state.cat = opt.cat;
      vue.arrival_state.max = opt.max;
      vue.prompt.arrival_cb = cb;
      vue.prompt.match_cnt = 0;
      vue.prompt.sent_cnt = 0;
      delete vue.prompt.single_room;
      if (vue.room && vue.room.getStats) {
        let stats = vue.room.getStats();
        vue.arrival_state.waiting = stats.acnt;
      }
      //console.log("Send Arrival",JSON.stringify(vue.arrival_state));
      vue.do_arrival_step();
    },
    do_arrival_step: function() {
      let vue = this;
      window.clearTimeout(vue.arrival_tid);
      wss_send_cb(vx, "arrival", {
        state: vue.arrival_state,
      }, function(msg) {
        //console.log("arrival_step",msg);
        if (!msg || !msg.data || !msg.data.ok) {
          /* Done with error */
          delete vue.arrival_state;
          vue.prompt.arrival_cb && vue.prompt.arrival_cb();
          return;
        }
        if (msg.data.cnt && msg.data.cnt > 0) {
          vue.prompt.sent_cnt += msg.data.cnt;
        }
        if (msg.data.match_cnt && msg.data.match_cnt > 0) {
           vue.prompt.match_cnt = msg.data.match_cnt;
           if (msg.data.m0) {
             vue.prompt.single_room = msg.data.m0;
           }
        }
        if (!msg.data.state || !msg.data.state.delay) {
          delete vue.arrival_state;
          vue.prompt.arrival_cb && vue.prompt.arrival_cb();
          return;
        }
        vue.prompt.arrival_cb && vue.prompt.arrival_cb();
        delete vue.prompt.arrival_cb;

        vue.arrival_state = msg.data.state;
        vue.arrival_tid = setTimeout(vue.do_arrival_step,
                                     vue.arrival_state.delay);
      });
    },
    callback_email_input: function(val) {
      let vue = this;
      vue.prompt.callback_email = val;
      vue.prompt.callback_valid = false;
      if (window.validate_email(val)) {
        vue.prompt.callback_email_valid = true;
        if (vue.prompt.callback_phone_valid) {
          vue.prompt.callback_valid = true;
        }
      } else if (!val) {
        vue.prompt.callback_email_valid = true;
        if (vue.prompt.callback_phone && vue.prompt.callback_phone_valid) {
          vue.prompt.callback_valid = true;
        }
      } else {
        vue.prompt.callback_email_valid = false;
      }
    },
    callback_phone_input: function(val) {
      let vue = this;
      vue.prompt.callback_phone = val.replace(/[\(\)\-\s]/g,"");
      vue.prompt.callback_valid = false;
      if (vue.prompt.callback_phone.length > 9 &&
          vue.prompt.callback_phone.match(/^\d+$/)) {
        if (vue.prompt.callback_phone.length == 10) {
          vue.prompt.callback_phone = "1" + vue.prompt.callback_phone;
        }
        vue.prompt.callback_phone_valid = true;
        if (vue.prompt.callback_email_valid) {
          vue.prompt.callback_valid = true;
        }
      } else if (!val) {
        vue.prompt.callback_phone_valid = true;
        if (vue.prompt.callback_email && vue.prompt.callback_email_valid) {
          vue.prompt.callback_valid = true;
        }
      } else {
        vue.prompt.callback_phone_valid = false;
      }
    },
    leave_message: function() {
      let vue = this;
      vue.$bvModal.hide('bv-wait-prompt');
      vue.presence.message_cb && vue.presence.message_cb();
    },
    isStaging: function() {
      //if (window.vx && window.vx.staging) {
      //  return true;
      //}
      return false;
    },
    set_pt_kbps: function() {
      let vue = this;
      vue.pt_kbps = vue.pt_kbps_in;
      vue.$parent.mydevice.set_pt_kbps(0|vue.pt_kbps);
    },
    uploadRestart: function(is_video) {
      let vue = this;
      if (!vue.$parent.mydevice.tupload_restart) { return; }
      let av = is_video ? "video" : "audio";
      console.log("restart "+av);
      vue.$parent.mydevice.tupload_restart(av);
      vue.rest_var[av] = "warning";
      setTimeout(function() {
        vue.rest_var[av] = "danger";
      }, 500);
    },
    uploadStall: function(is_video) {
      let vue = this;
      if (!vue.$parent.mydevice.tupload_stall) { return; }
      let av = is_video ? "video" : "audio";
      console.log("stall "+av);
      vue.$parent.mydevice.tupload_stall(av,3000);
    },
    showPreview: function() {
      if (!this.$parent.mydevice.has_preview) {
        return false;
      }
      if (!this.$parent.video_enabled) {
        return false;
      }
      return this.showStartCapture();
    },
    showStartCapture: function() {
      if (!this.$parent.mydevice.can_capture) {
        return false;
      }
      if (this.$parent.mydevice.capture_state != "off") {
        return false;
      }
      if (this.$parent.mydevice.has_preview) {
        /* Make sure render started before allowing capture */
        if (this.$parent.selected_video_group != this.$parent.mydevice.preview_video_group ||
            this.$parent.selected_video_source != this.$parent.mydevice.preview_video_source) {
            return false;
        }
      }
      return true;
    },
    showStopCapture: function() {
      if (!this.$parent.mydevice.can_capture) {
        return false;
      }
      if (this.$parent.mydevice.capture_state == "off") {
        return false;
      }
      return true;
    },
    grabThumbnail: function() {
       let vue = this;
       let can = document.getElementById("pvw_self");
       vue.cap_tn = can.toDataURL("image/png");       
       $("#pvw_tn").html("<img class=\"mytn\" src="+vue.cap_tn+"></img>");       
    },
    keepThumbnail: function() {
       let vue = this;
       /* Skip "data:image/png;base64," and decode */
       let raw = new Buffer(vue.cap_tn.substring(22), 'base64');
       vx_api.createMyTn(window.vx, {}).then(stream => {
         if (stream && stream.upload && stream.upload.vxshare) {
            api_put_awsfile(stream.upload.vxshare,
              {content_type:"image/png",
               payload:raw}, function(status,data) {
                 //console.log("tn:"+status);
                 vue.cap_tn = null;
               });
         }
       });
    },
    set_scfg: function(match,prefix) {
      if (!match || !match.scfg) { return; }
      match.scfg.forEach(function(t) {
        if (t[prefix+"_crf"]) {
           t["crf"] = t[prefix+"_crf"];
        }
        if (t[prefix+"_maxrate"]) {
           t["maxrate"] = t[prefix+"_maxrate"];
        }
        if (t[prefix+"_bufsize"]) {
           t["bufsize"] = t[prefix+"_bufsize"];
        }
      });
    },
    get_scfg: function(cond) {
      let vue = this;
      let lv = vue.$parent.currentUser.lv_formats;
      let match;
      let fallback;
      for (let i = 0; i < lv.length; i++) {
        var fm = lv[i];
        if (fm.cond.includes(cond)) {
          match = fm;
          break;
        }
        if (!fallback && fm.cond.includes("default")) {
          fallback = fm;
        }
      }
      return match || fallback;
    },
    bgImageError() {
      let vue = this;
      vue.$parent.mydevice.bgef.img = "";
    },
    bgImageSelected(url) {
      let vue = this;
      if (vue.bg_selected_img != url) {
        vue.bg_selected_img = url;
      }
      vue.$parent.mydevice.bgef.isel = true;
      vue.$parent.mydevice.bgef.img = url;
      window.setLocal("vx_bg_ef",JSON.stringify(vue.$parent.mydevice.bgef));
      vue.$parent.mydevice.change_vid_src({
        sel_video: vue.$parent.selected_video_source,
      });
    },
    update_bg_ef_on: function() {
      let vue = this;
      vue.$parent.mydevice.bgef.isel = true;
      window.setLocal("vx_bg_ef",JSON.stringify(vue.$parent.mydevice.bgef));
      vue.$parent.mydevice.change_vid_src({
        sel_video: vue.$parent.selected_video_source,
      });
    },
    update_bg_ef_off: function() {
      let vue = this;
      vue.$parent.mydevice.bgef.isel = false;
      window.setLocal("vx_bg_ef",JSON.stringify(vue.$parent.mydevice.bgef));
      vue.$parent.mydevice.change_vid_src({
        sel_video: vue.$parent.selected_video_source,
      });
    },
    update_audcap: function(k) {
      let vue = this;
      vue.audcap = k;
    },
    discardThumbnail: function() {
       let vue = this;
       vue.cap_tn = null;
       $("#pvw_tn").html("<img class=\"mytn\" src=\""+window.vx_user_tn(null,true)+"\"></img>");
    },
    enableVideo: function() {
      let vue = this;
      vue.$parent.mydevice.change_vid_src({
        capture: true,
        video_pt: vue.$parent.video_max == 3,
        sel_video: vue.$parent.selected_video_source,
      }, function(status) {
        if (status == "ok") {
          vue.closePanel();
        }
      });
    },
    startCapture: function(cond,with_video) {
      // eslint-disable-next-line
      if (vx && vx.debug) { console.log("starting capture " + cond); }
      let vue = this;
      let cmds = vue.$parent.currentUser.commands;
      let match;
      let mytags = [];
      let is_pres = false;

      /* Force reselection of background group/source at new capture */
      window.setLocal("vx_agroup1",null);
      window.setLocal("vx_asource1",null);
      if (!with_video) {
        vue.$parent.mydevice.stop_render({ao:true});
        vue.$parent.selected_video_source = null;
      }

      match = vue.get_scfg("default");
      if (vue.$parent.mydevice.get_av_sources) {
         if (with_video) {
           if (vue.$parent.video_sources) {
             if (vue.$parent.selected_video_source === null) {
               // eslint-disable-next-line
               console.log("No video source selected",vue.$parent.selected_video_source);
               return;
             }
             vue.set_scfg(match, vue.$parent.selected_video_prefix);
           }
         }
         if (vue.$parent.audio_sources &&
             vue.$parent.selected_audio_source[0] === null) {
           // eslint-disable-next-line
           console.log("No audio source selected");
           return;
         }
      }

      mytags.push("is_obs=true");
      if (match) {
        let fmts = match.streams.join(",");
        // eslint-disable-next-line
        if (vx && vx.debug) { console.log("Selected " + match.cond + " " + fmts); }
        vx_api.createStream(window.vx,
          { formats: fmts }).then(stream => {
          if (stream && stream.upload) {
            let sndbuf = 1024*(0|vue.curlsend);
            if (vx.indomain) {
              stream.upload.post_url =
                stream.upload.post_url.replace(/\/\/.*\.vuemix\.com/,
                                               "//"+vx.indomain);
            }
            if (sndbuf) {
              stream.upload.curl = [];
              /* SendBuf */
              stream.upload.curl.push("65535,4097,"+sndbuf);
              /* NoDelay */
              stream.upload.curl.push("6,1,1");
              //console.log("curl:"+JSON.stringify(stream.upload.curl));
            }
            api_update_ulloc(stream.upload.post_url);
            if (stream.upload.httphdrs) {
              let s = "";
              let u = vue.$parent.currentUser;
              if (u) {
                s += u.id + " " + u.first_name + " " + u.last_name + " ";
              }
              if (window.vx.about) {
                let ab = window.vx.about;
                if (ab.app_version) { s += " app:"+ab.app_version; }
                if (ab.os_version) { s += " os:"+ab.os_version; }
              }
              u = window.vx.sysinfo;
              if (u) {
                if (u.intel) { s += " intel:"+u.intel; }
                if (u.amd) { s += " amd:"+u.amd; }
                if (u.windows) { s += " win:"+u.windows; }
                if (u.mac) { s += " mac:"+u.mac; }
                if (u.apple) { s += " apple:"+u.apple; }
                if (u.andr) { s += " andr:"+u.android; }
                if (u.cpu) { s += " cpu:"+u.cpu; }
                if (u.cores) { s += " cores:"+u.cores; }
                if (sndbuf) { s += " curl:"+JSON.stringify(sndbuf); }
              }
              stream.upload.httphdrs["vxmob-info"] = s;
              stream.upload.httphdrs["vx-s"] = Math.random().toString(36).substring(2,15);
              //stream.upload.httphdrs["vxmob-hburl"] =
              //    stream.upload.httphdrs["vxmob-hburl"].replace
              //      ("gm6cye9fdg.execute-api.us-east-1.amazonaws.com/dev",
              //       "devdev.staging.vuemix.com:8443/dev");
            }
          }
          if (window.vx.user && window.vx.user.ss && window.vx.user.ss != "-") {
            /* Start capture should never have existing screen share */
            window.vx.user.ss = "-";
            window.api_clear_sshare(window.vx, {ss:"-"});
          }
          /* createStream clobbers any existing stream for user.
             Force an update. */
          if (vue.userarate) {
            match.arate = vue.userarate*1024;
            if (vx && vx.debug) { console.log("fmt:"+JSON.stringify(match)); }
          }
          //stream.upload.post_url = "http://arctest.vuemix.com:8080/upload/";
          //stream.upload.httphdrs["vxmob-dumpit"] = "1";
          cmds.push("lost_connectivity_restart=2");
          vue.$parent.mydevice.capture_state = "unknown";
          window.vx_vid_set(stream.upload.id, stream.upload.video_id, function(vidmsg) {
            if (!vidmsg || !vidmsg.data || !vidmsg.data.ok) {
               let err = "Unable to create your stream."
               if (vidmsg && vidmsg.data && vidmsg.data.error) {
                 err += vidmsg.data.error;
               }
               vue.notify("err",err);
               vue.$parent.mydevice.capture_state = "off";
               return;
            }
            vue.$parent.mydevice.start_capture(
              {sel_video: vue.$parent.selected_video_source,
               sel_audio: vue.$parent.selected_audio_source[0],
               cmds: cmds, fmt: match,
               upload: stream.upload,
               is_pres: is_pres,
               bskipon: vue.bskipon,
               skipth: vue.skipthresh,
               vpbypass: (vue.vpbypass == "true"),
               nsdb: (0|vue.nsdb),
               video_fct: vue.video_fct,
               video_sm: true,
               video_lg: vue.$parent.video_max == 2,
               video_pt: vue.$parent.video_max == 3,
               audcap: vue.audcap,
               notify: vue.notify,
            });
            if (vue.is_on_home) {
               window.wss_send(window.vx, "add_to_home", {
                vdbid: stream.upload.id,
                vid: stream.upload.video_id,
                tn: vx_user_tn()});
            }
          });
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            vue.$parent.signUserOut("", "Your session has expired", "warning");
          } else {
            console.warn(error);
          }
        });
      }
    },
    update_video_rc: function() {
      let vue = this;
      if (!vue.$parent.video_enabled) { return; }
      if (!vue.$parent.video_sources) { return; }
      if (!vue.$parent.mydevice.set_video_rc) { return; }
      let match = vue.get_scfg("default");
      vue.set_scfg(match, vue.selected_video_prefix);
      vue.$parent.mydevice.set_video_rc(match.scfg, function(err) {
      });
    },
    stopCapture: function() {
      let vue = this;
      // eslint-disable-next-line
      console.log("stopping capture");
      vue.$parent.exit_listener = null;
      vue.$parent.mydevice.capture_state = "unknown";
      vue.$parent.sel_audio_idx = 0;
      vue.$parent.mydevice.stop_capture({}, function(err,data) {
         vue.$parent.mydevice.stop_share();
         vue.is_on_home = false;
         if (vue.$router.from_bcast) {
            vue.$router.push({name: "cast"});
            return;
         }
         if (err) {
           // eslint-disable-next-line
           console.log("Error");
         } else {            
            //console.log("Success");
            /* Clear to force preview restart following stop */
            vue.$parent.refreshAVSources({notify:vue.notify});
         }
      });
    },
    queryAudioActivity: function() {
      let vue = this;
      vue.$parent.mydevice.query_audio_activity(function(act) {
         if (act < 75) {
           vue.audio_activity1 = act;
           vue.audio_activity2 = 0;
           vue.audio_activity3 = 0;
         } else if (act < 105) {
           vue.audio_activity1 = 75;
           vue.audio_activity2 = act-75;
           vue.audio_activity3 = 0;
        } else {
           vue.audio_activity1 = 75;
           vue.audio_activity2 = 30;
           vue.audio_activity3 = act-105;
         }
      });
      if (vue.capturePanelIsOpen) {
         window.setTimeout(vue.queryAudioActivity, 300);
      }
    },
    onCapturePanelOpen: function() {
      let vue = this;
      // eslint-disable-next-line
      if (vx && vx.debug) { console.log("panel opening"); }
      window.NSV_update({cpanel:true,stop:true});
      if (vue.room.dohide("onlywatch")) {
        vue.onlywatch = false;
      } else {
        vue.onlywatch = true;
      }
      if (vue.room.dohide("enablevid")) {
        vue.enablevid = false;
      } else {
        vue.enablevid = true;
      }
      vue.capturePanelIsOpen = true;
      if (window.vx.dc && window.vx.dc) {
        let dcs = window.vx.dc;
        Object.keys(dcs).forEach(function(dc) {
          if (!dcs[dc].selected) { return; }
          let info = vue.$parent.dc2name(dcs[dc].dc);
          vue.captureDC = info.r;
        });
      }
      vue.updateStopColor(vue.$parent.mydevice.capture_state);
      vue.$parent.refreshAVSources({notify:vue.notify});
      vue.queryAudioActivity();
      vue.discardThumbnail();
      vue.bg_selected_img = vue.$parent.mydevice.bgef.img || "";
      window.wss_open(vx, {
         acc: vx.room && vx.room.acc,
         room: vx.room && vx.room.name,
         routes_id: "cpanel",
         routes: {
            on_home: function(msg) {
               if (msg.data.v === true) {
                  vue.is_on_home = true;
               } else if (msg.data.v === false) {
                  vue.is_on_home = false;
               }
            }
         }
      });
      vue.getOnHome();
    },
    onCapturePanelClose: function(e) {
      let vue = this;
      // eslint-disable-next-line
      if (vx && vx.debug) { console.log("panel closing"); }
      window.NSV_update({cpanel:false});
      if (!vue.allow_close && !vue.$parent.amStreaming()) {
        e.wait = true;
        if (vue.onlywatch) {
          vue.notify("err",'You must "Join" or choose to "Only Watch".');
        } else {
          vue.notify("err",'You must "Join".');
        }
        return;
      }
      vue.allow_close = false;
      vue.capturePanelIsOpen = false;
      if (window.vx && window.vx.room && window.vx.room.auto_join) {
         if (vue.$parent.mydevice.capture_state != "capturing") {
           window.vx.room.auto_join = false;
           window.vx.room.auto_raise = false;
           window.vx_pvw_cancel();
         } else {
         }
      }
      window.do_unmute && window.do_unmute();
      window.wss_clr_routes(window.vx,"cpanel");
    },
    videoSelectionLocked: function() {
      if (!this.$parent.mydevice.otf_src_change &&
          this.$parent.mydevice.capture_state != "off") {
        return true;
      }
      return false;
    },
    audioSelectionLocked: function() {
      if (this.$parent.mydevice.capture_state != "off") {
        if (!this.$parent.mydevice.otf_src_change ||
            !this.$parent.mydevice.change_aud_src) {
          return true;
        }
      }
      return false;
    },
    onVideoSourceChange: function() {
      let vue = this;
      vue.$parent.onVideoSourceChange(false,{notify:vue.notify});
    },
    onAudioGroupChange: function() {
      let vue = this;
      vue.$parent.onAudioGroupChange(false,{notify:vue.notify});
    },
    onAudioSourceChange: function() {
      let vue = this;
      vue.$parent.onAudioSourceChange(false,{notify:vue.notify});
    },
    onSpeakerSourceChange: function() {
      let vue = this;
      vue.$parent.onSpeakerSourceChange(false,{notify:vue.notify});
    },
    config_audio: function(idx) {
      let vue = this;
      if (idx == vue.$parent.sel_audio_idx) { return; }
      vue.$parent.sel_audio_idx = idx;
      vue.$parent.refreshAVSources({notify:vue.notify});
    },
    
    flipCamera: function() {
      //console.log("flip camera");
      let vue = this;
      vue.$parent.mydevice.flip_camera();
    },
    micToggle: function() {
      if (this.micState.state) {
        this.micState.state = false;
        this.micState.caption = "Mic Off";
        if (this.$parent.mydevice.bridge_kind == "ios") {
          //console.log("capbrPost mute");
          window.capbrPost("mute", {});
        }
      } else {
        this.micState.state = true;
        this.micState.caption = "Mic On";
        if (this.$parent.mydevice.bridge_kind == "ios") {
          //console.log("capbrPost unmute");
          window.capbrPost("unmute", {});
        }
      }
    },
    getOnHome: function() {
      let vue = this;
      if (this.$parent.mydevice.capture_state != "off") {
         window.wss_send(window.vx, "is_on_home", {});
      }
    },
    showarate: function() {
       return true;
       let vue = this;
       if (!vue.$parent.currentUser) { return false; }
       if (vue.$parent.currentUser.email.indexOf("vuemix") > 0) {
         return true;
       }
       return false;
    },
    setShowOnHome: function(show) {
      let vue = this;
      vue.is_on_home = show;
      if (this.$parent.mydevice.capture_state != "off" &&
          vx.user && vx.user.vdbid) {
        if (vue.is_on_home) {
          window.wss_send(window.vx, "add_to_home", {
            tn: vx_user_tn()
          });
        } else {
          window.wss_send(window.vx, "rm_from_home", {});
        }
      }
    },
    visChanged: function() {
      let vue = this;
      if (vue.$parent.mydevice.release_on_hide) {
        if (vx && vx.debug) { console.log("vuehidden:"+document.hidden); }
        /* Hiding while not capturing but inside room goes ahead
           ahead and disables the camera (instead of stop render)
           to avoid confusion when restored. */
        if (document.hidden) {
          vue.$parent.mydevice.stop_render();
        } else {
          vue.$parent.refreshAVSources({notify:vue.notify});
        }
      }
    },
    deviceChanged: function() {
      let vue = this;
      if (!vue.capturePanelIsOpen) { return; }
      vue.$parent.refreshAVSources({notify:vue.notify});
    },
    check_room_mode: function(name) {
      let vue = this;
      if (name == "room-camonly") {
         vue.$parent.mydevice.only_show_self = true;
         jsMSE.set_noop();
      } else {
         delete vue.$parent.mydevice.only_show_self;
         jsMSE.clr_noop();
      }
    },
    exit_listener: function() {
      let vue = this;
      if (vue.$router.from_bcast) {
         vue.stopCapture();
      }
    },
    dial_send_dtmf: function() {
      let vue = this;
      let val = ""+vue.dial_dtmf;
      if (vue.$refs.dtmf_input_box) {
        vue.$refs.dtmf_input_box.reset();
      }
      if (!vue.sig) { return; }
      vue.sig.send_dtmf(val);
    },
    dial_mute_toggle: function() {
      let vue = this;
      if (!vue.sig) { return; }
      vue.dial_set_muted(vue.sig.mute_toggle());
    },
    dial_set_muted: function(val) {
      let vue = this;
      if (val) {
        vue.dial_muted = true;
        vue.dial_mute_text = "MUTED"
        vue.dial_mute_variant = "danger"
      } else {
        vue.dial_muted = false;
        vue.dial_mute_text = "Mute Call"
        vue.dial_mute_variant = "outline-secondary"
      }
    },
    trigger_dial: function(opt) {
      let vue = this;
      if (vx && vx.debug) { console.log("Dial",opt.info); }
      if (vue.sig) {
         if (vx && vx.debug) { console.log("Already in a call"); }
         return;
      }
      let j = to_json(opt.info);
      let SigWire = sig();
      let elp_base;
      vue.sig = new SigWire();
      vue.dial_show = true;
      vue.dial_status = "";
      vue.dial_elapse = "";
      vue.dial_disable = false;
      vue.dial_dtmf = "";
      delete vue.dial_elp_base;
      vue.sig.init({
        project: j.id,
        token: j.token,
        number: j.number,
        get_audio_el: function() {
           let an = document.getElementById("__dialaudio");
           if (!an) {
              an = document.createElement("audio");
              an.muted = false;
              an.id = "__dialaudio";
              an.controls = true;
              an.style="position:absolute;top:150px;left:10px;width:200px;height:30px;z-index:1000;visibility:hidden;"
              let body = document.getElementsByTagName("body")[0];
              body.append(an);
           }
           an.ontimeupdate = function() {
             let tm = an.currentTime;
             if (tm >= 0) {
                if (elp_base === undefined) {
                   elp_base = tm;
                }
                vue.dial_elapse = ""+Math.round(Math.abs(tm - elp_base));
             }
           };
           return an;
        },
        cb: function(state,uistate,muted) {
           if (state == "disconnected") {
             let an;
             vue.dial_status = "call ended";
             vue.dial_disable = true;
             if ((an = document.getElementById("__dialaudio"))) {
               an.pause();
               an.remove();
               an.src = "";
               an.srcObject = null;
             }
             vue.sig = null;
             if (vue.$parent.mydevice.is_ios_browser) {
               vue.$parent.mydevice.change_aud_src({
                  sel_idx: 0,
                  sel_audio: vue.$parent.selected_audio_source[0],
               });
             }
             setTimeout(function() {
               vue.dial_show = false;
             }, 2000);
           } else if (state == "disconnecting" || uistate == "hangup") {
             vue.dial_status = "hanging up";
             vue.dial_disable = true;
           } else if (state == "connecting") {
             vue.dial_status = "dialing";
           } else if (state == "connected" && uistate == "outring") {
             vue.dial_status = "ringing";
           } else if (state == "connected" && uistate == "talk") {
             vue.dial_status = "talking";
           }
           vue.dial_set_muted(muted);
        },
      });
      vue.sig.connect();
    },
    dial_hangup: function() {
      let vue = this;
      vue.sig.hangup();
    },
  },
  mounted() {
    let vue = this;
    //console.log("room mounted",vue.$router.currentRoute.name);
    this.check_room_mode(vue.$router.currentRoute.name);
    this.bskipon = window.vx.about.level || 0;
    this.$parent.set_room_background();

    this.room = new RoomCore;
    window.vx_set_room(window.vx, this.acc, this.uid);
    vue.startFresh();
    vue.last_open = {acc: window.vx.room.acc, name: window.vx.room.name};
    vxslog({p:"room",a:"open"});

    this.audio_gain = this.$parent.mydevice.get_audio_gain() || 1;
    this.change_audio_gain();
    this.is_on_home = false;    
    document.addEventListener("visibilitychange", this.visChanged, false);
    navigator.mediaDevices.ondevicechange = function() {
      vue.deviceChanged();
    }

    this.$parent.exit_listener = this.exit_listener;
    if (this.$parent.mydevice.can_capture &&
      this.$parent.mydevice.capture_state != "capturing") {
      if (this.$parent.auto_start_capture == 'video') {
         this.startCapture('presenter',true);
      } else if (this.$parent.auto_start_capture == 'audio') {
         this.startCapture('presenter',false);
      }
      this.$parent.auto_start_capture = null;
    }
    vue.dc_ready = false;
    vuemix_vs_selected(function() {
      console.log("room, dc_ready");
      vue.dc_ready = true;
    });
  },
  beforeDestroy() {
    this.$parent.mydevice.stop_render();

    this.room && this.room.cleanup();
    delete window.updateUserState;

    this.reset_prompt();

    this.$parent.eventid = "";
    this.$parent.exit_listener = null;
    this.$parent.set_background();
    document.removeEventListener("visibilitychange", this.visChanged, false);
    navigator.mediaDevices.ondevicechange = null;

    // room info may be cleared out by Home or other routes. Include
    // info for last room that was opened to help with clarity
    vxslog({p:"room",a:"leave",r: this.last_open});
  }
};
</script>
<style lang="scss">
/* ============================== */

.btn {
  margin-right: 5px;
  margin-bottom: 10px;
}

.turtle {
  position: absolute;
  font-size: 30px;
  bottom: 0;
  right: 0;
  color: rgba(0, 0, 200, 0);
}
.turtle[delay="med"] {
  color: rgba(255, 235, 0, 0.3);
}
.turtle[delay="high"] {
  color: rgba(255, 100, 0, 0.5);
}
.turtle[delay="vhigh"] {
  color: rgba(200, 0, 0, 0.7);
}

.aonly {
  position: absolute;
  font-size: 8px;
  margin: 20%;
  color: rgba(200, 50, 50, 1);
  display:none;
}
.content,
.flex_fill {
  flex: 1 1 0;
}

.content {
  position: relative;
}

#roomtop {
  display:flex;
  flex-direction: column;
  flex-wrap: no-wrap;
  height: calc(100vh - 50px);
}

#brand_banner {
 flex: 0 0 3rem;
 /*background-color: rgba(255,0,0,0.4);*/
}

.wall_container {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  position: relative;
}

#dial_controls {
  position: absolute;
  width: 30rem;
  top: 20vh;
  left: calc(50vw - 15rem);
  z-index: 10;
  text-align: center;
  padding: 0.5rem 0.3rem;
  background-color: #222222;
  color: white;
  border: 1px solid #444444;
  border-radius: 5px;
}

.dial-status {
  font-size: 0.7rem;
}

.dial_dtmf {
  display:inline-block;
  font-size:0.95rem;
  width:12rem;
  max-width:70%;
  margin: 0 0.5rem;
}

.dial_mute {
  display:inline-block;
  margin: 0 0.5rem;
}

#room_wall {
  //position: absolute;
  width: 100%;
  height: 100%;
  //top:0;
  //bottom:0;
  //left:0;
  //right:0;
  //min-height: calc(100vh - 56px);
}

.aoplaceholder {
  position: absolute;
  background-color:#1020a0;
  border-radius:50%;
  width: 8vh;
  height: 8vh;
  left: calc( 50% - 4vh );
  top: calc( 50% - 4vh );
  text-align: center;
  line-height: 8vh;
  color: white;
  font-size: 2.5vh;
}

.panel3 {
  /*overflow:hidden;*/
  position: absolute;
  display: flex;
  z-index: 1;
  flex-flow: column;
  /*justify-content:flex-end;*/
  max-width:95%;
  width: 20rem;
  top:20%;
  left: calc(50% - 10rem);
  background-color: #ffffff;
  border: solid 1px black;
  border-radius: 3px;
  font-size: 0.9rem;
}

.ct_misc_label {
  flex: 0 0 auto;
  padding: 3px 8px;
  cursor: pointer;
  position: relative;
  display:block;
  height: 2rem;
}

.ct_misc_name {
  cursor: default;
  font-weight: bold;
  font-size: 1rem;
}

.ct_misc_sep {
  border-bottom: 1px solid black;
}

.ct_misc_btn {
  flex: 0 0 auto;
  padding: 3px 8px;
  cursor: pointer;
  position: relative;
  display:block;
  height: 2rem;
  color: #000000;
  font-weight:bold;
}

.ct_misc_btn_trntop {
  position:relative;
  margin: 0 2px;
  padding:1px;
  border-radius: 5px;
  height: fit-content;
}

.ct_misc_btn_trntop {
  font-size: 0.9rem;
  color: red;
}

.ct_misc_btn_selfblock_aud {
  cursor: not-allowed;
  color: #505050;
  font-weight: 200;
}

.ct_misc_btn_eject {
  color: #b00000;
  font-weight:bold;
}

.ct_misc_btn:hover {
  background-color: #e0c060;
}

.panel4 {
  overflow:hidden;
  position: absolute;
  display: flex;
  z-index: 1;
  flex-flow: column;
  /*justify-content:flex-end;*/
  max-width:95%;
  width: 20rem;
  top:20%;
  left: calc(50% - 10rem);
  background-color: #ffffff;
  border: solid 1px black;
  border-radius: 3px;
  font-size: 0.9rem;
}

.ct_1on1_label {
  flex: 0 0 auto;
  padding: 3px 8px;
  cursor: pointer;
  position: relative;
  display:block;
  /*height: 2rem;*/
  line-height:1rem;
}

.ct_1on1_accept {
  color:white;
  background-color:#218838;
  border-radius: 5px;
}

.ct_1on1_deny {
  color:white;
  background-color:#bd2130;
  border-radius: 5px;
}

.panel_btn_mirror {
  text-align: center;
  color: white;
}

.panel_btn_ctrl {
}

.panel_btn_ctrl[picked="true"] {
  background-color:#e03535;
  border-radius:2px;
}

#brktitle {
  color: #ffffff;
  text-align:center;
  font-size: 0.7rem;
}
.panel2_btn_brk, .panel_btn_abr, .panel_btn_live {
  text-align:center;
  font-size: 0.7rem;
  /*background-color: rgba(200,200,200,0.2);*/
  border-radius: 3px;
  line-height: 35px;
}
.panel2_btn_brki {
  line-height: 0.9rem;
  font-size:0.6rem;
  letter-spacing: 0.05rem;
}
.panel2_btn_brkinput {
  width:100%;
  text-align:center;
  font-size:.8rem;
  line-height:.7rem;
}

@media screen and (max-width:600px) and (orientation:portrait) {
 .vxwport {
   top: 0px !important;
 }
}

.panel_btn_abri {
  display:none;
  font-size: 10px;
  color: #309090;
}
.panel_btn_abri[at="true"] {
  display:block;
  color: #309090;
  /*background-color:rgba(200,50,50,0.2);*/
  /*border-radius:2px;*/
}

.panel_btn_ctrl {
}
.panel_btn_ctrl[picked="true"] {
  background-color:#e03535;
  border-radius:2px;
}

.panel {
  /* overflow:hidden; */
  position: absolute;
  display: flex;
  opacity:0;
  z-index: 1;
  flex-flow: row;
  bottom:0;
  left:0;
  width:100%;
  justify-content:space-around;
  transition: opacity 1s;
}

.panel_sub {
  flex: 0 0 auto;
  display: flex;
  flex-flow: row;
  border: solid 1px rgba(80,90,90,1);
  border-radius: 5px;
  margin-right: 0.1rem;
  margin-left: 0.1rem;
}

//.nav-wrapper:hover ~ .page .panel {
//  opacity:1;
//}

.panel[isopen=false] {
  display: none;
}

.panel:hover, .panel:focus, .panel[isopen=true], .panel[help="on"] {
  display: flex;
  opacity:1;  
  /*transition: opacity 0.25s;*/
}

.panel_btn {
  cursor: pointer;
  position: relative;
  flex: 0 0 auto;
  width: 5vw;
  max-width: 35px;
  height: 5vw;
  max-height: 35px;
  outline: none;
  /* padding: 1px 3px; */
  color: #b0a0a0;
  margin: auto 0.2rem;
  background-color: rgb(26, 26, 29);
  border-radius: 5px;
  border: solid 1px #807070;
}

.panel_btn[picked="true"] {
  background-color: #801010;
}

.panel_btn:hover {
  /*background-color: #101510;*/
  /*box-shadow: 1px 1px 1px #808080;*/
  border: solid 1px white;
  /*color:white;*/
}

.panel_btn:hover .vxic {
  /*stroke:white;*/
}

.panel_btn[picked="true"]:hover {
  /*background-color: #802010;*/
}

.panel_btn_r[data-descr]:hover::after {
  content: attr(data-descr);
  position: absolute;
  right: 0;
  top: -1.7rem;
  font-size: 0.7rem;
  font-weight: 600;
  font-family: sans-serif;
  white-space: nowrap;
  line-height: 1.2rem;
  height:auto;
  width:fit-content;
  color:black;
  background:white;
  padding: 0 5px;
  border-radius: 2px;
  border: none;
  z-index: 1;
}

.panel_btn_l[data-descr]:hover::after {
  content: attr(data-descr);
  position: absolute;
  left: 0;
  top: -1.7rem;
  font-size: 0.7rem;
  font-weight: 600;
  font-family: sans-serif;
  white-space: nowrap;
  line-height: 1.2rem;
  width:fit-content;
  color:black;
  background:white;
  padding: 0 5px;
  border-radius: 2px;
  z-index: 1;
}

.btn_help {
  display: none;
  position: fixed;
  bottom: calc(50px + 2.9rem);
  left: calc(50% - 8rem);
  width: fit-content;
  /*padding: 0 1rem;*/
  font-size: 0.8rem;
  text-align: center;
  border: solid yellow 1px;
  border-radius: 5px;
  color: white;
  background-color: black;
}

.btn_help_msg {
  margin: 0 0.5rem;
}

.btn_help_dm,.btn_help_dmf {
  line-height:1;
  border-radius: 5px;
  font-size:0.7rem;
  font-weight: 600;
  width:6rem;
  min-height: 1rem;
  color: white;
  background-color: #101010;
  margin: 0.1rem 0.3rem;
}

.panel_btn[help="on"] {
  border: solid yellow 1px;
  box-shadow: 0 0 1rem yellow;
}

.panel_btn[help="on"] > .btn_help {
  display: block;
}

.panel_btn_mode_0 {
  margin: 4px;
  padding: 0 auto;
}

.panel_btn_mode_1 {
  margin: 4px;
  padding: 0 auto;
}

.panel_btn_join[disable="true"]:hover::after {
  content: "You are not allowed to participate.";
}

.panel_btn_join[disable="true"] {
  cursor:not-allowed;
  background-color:#404040;
  box-shadow: none;
}

@media screen and (max-width:600px) and (orientation:portrait) {
 .panel {
    flex-wrap:wrap;
    justify-content:center;
 }
 .nav-wrapper:hover ~ .page .panel {
    background-color:transparent;
 }
 .panel {
    transition: opacity 1s;
 }
 .panel:hover {
    background-color:transparent;
 }
 .panel_btn {
    width: 12vw;
    max-width: 40px;
    height: 12vw;
    max-height: 40px;
 }
 .btn_help {
    bottom: 130px;
 }
 .panel_btn_r[data-descr]:hover::after {
   display: none;
 }
 .panel_btn_l[data-descr]:hover::after {
   display: none;
 }
}


.panel_btn_exit_q::after {
  content: attr(order);
  position: absolute;
  width: 18px;
  height: 18px;
  right: 2px;
  top: 12px;
  border: solid 1.5px white;
  border-radius: 50%;
  background-color: white;
  color: rgb(0, 0, 0);
  font-size: 14px;
  font-family: "Roboto Condensed";
  font-weight: bold;
  line-height: 20px;
  text-align: center;
}

.panel_tfps {
  position:absolute;
  bottom: 0.5rem;
  right: 2rem;
  z-index: 10;
  color: #ff5050;
  background-color: black;
  border-radius: 0.25rem;
  line-height: 0.8rem;
  margin-left: 0.5rem;
  margin-top:  0.5rem;
  font-size: 0.65rem;
}

.panel_stats {
  position:absolute;
  top: 0;
  left: 0;
  z-index: 10;
  color: #ff5050;
  background-color: white;
  border-radius: 0.25rem;
  line-height: 0.8rem;
  margin-left: 0.5rem;
  margin-top:  0.5rem;
}

.one_stat {
  margin: 0 0.25rem;
  font-size: 0.65rem;
}

.chat_panel {
  display: none;
  position: absolute;
  bottom: 2vw;
  width: 60%;
  margin: 0 20%;
  z-index: 1;
  text-align: center;
  font-size: 20x;
  font-family: "Roboto Condensed";
  height: 200px;
  pointer-events: none;
}

.chat_panel_input {
  position: absolute;
  bottom:0;
  display:flex;
  flex-direction:column;
  width: 100%;
  border-radius: 8px;
}

@media screen and (max-width:600px) and (orientation:portrait) {
  .chat_panel {
    bottom: 120px;
    width: 95%;
    margin: 0 2%;
  }
}

.chat_panel_ibox {
  padding: 10px 0;
}

#chat_ibox {
  width: 80%;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  pointer-events: all;
}

#chat_ibox::placeholder {
  color: #d63232;
  padding: 0 0 0 10px;
}

.chat_panel_msgs {
  display: flex;
  flex-direction: column;
}

.chat_line {
  display: flex;
  flex-direction: row;
  line-height:20px;
  padding: 2px 0;
}
.chat_line_from_outer {
  flex: 2 0 10px;
  text-align:right;
}
.chat_line_from {
  border-radius:10px;
  padding: 0 5px;
  pointer-events: all;
}
.chat_line_msg_outer {
  padding: 0 0 0 15px;
  flex: 7 0 10px;
  text-align:left;
}
.chat_line_msg {
  border-radius:10px;
  padding: 0 10px;
  display: inline-block;
  pointer-events: visible;
}

.pg_panel {
  position: absolute;
  display: flex;
  flex-flow: row;
  height: 30px;
  z-index: 1;
  text-align: center;
  font-size: 18px;
  font-family: "Roboto Condensed";
}

.pg_panel_btn {
  flex: 0 0 auto;
  padding: 2px;
  width: 22px;
  color: rgba(255, 255, 255, 0.3);
}

@media screen and (max-width:600px) and (orientation:portrait) {
 .pg_panel {
   /*background-color: green;*/
   font-size: 6vw;
   margin: 30px 0 0 0;
 }
 .pg_panel_btn {
   width:12vw;
 }
}

.pg_panel_btn[enabled="1"] {
  color: white;
  cursor: pointer;
}

.pg_panel_label {
  flex: 0 0 auto;
  padding: 2px;
  width: 22px;
  color: white;
}

.ct_panel {
  position: absolute;
  display: flex;
  flex-flow:row-reverse;
  flex-wrap:wrap;
  right: 0;
  left: 0;
  justify-content: center;
  top: 3px;
  /*padding: 1px 3px;*/
  /*max-width:70%;*/
  height:28px;
}

.ct_panel_btn {
  display: none;
  flex: 0 0 auto;
  cursor: pointer;
  margin: 1px 1px;
  line-height:0;
  border-radius:5px;
  background-color: rgba(50, 50, 50, 1);
  z-index:2000;
}

.ct_panel_btn_always {
  flex: 0 0 auto;
  cursor: pointer;
  margin: 1px 1px;
  line-height:0;
}

.vxwc:hover .ct_panel_btn {
  display: block;
}

.ct_panel_btn > svg, .ct_panel_btn_always > svg {
  width: 22px;
  min-width: 15px;
  max-height: 22px;
}

.sval {
  margin: 5px;
  color: rgb(200, 150, 0);
}

.vxic {
  fill: none;
  stroke: #807070;
  stroke-width: 1;
  margin: 2px;
}
.vxic-pra {
  stroke-width: 3;
}

.vxic-prr {
  stroke: white;
  stroke-width: 3;
}

.vxic-kvr {
}
.vxic-kvs {
}

.ct_panel_btn > .vxic {
  stroke: white;
  stroke-width: 3;
}
.ct_panel_btn > .vxic-rx {
  stroke-width: 4;
}


.vxic-hd {
  padding: 1px;
}

.vxic-hr,
.vxic-mubl {
  fill: #e03535;
}
.vxic-mubl {
    animation:blinkingMute 0.8s infinite;
}
@keyframes blinkingMute {
    0%{     fill: rgb(150, 50, 50);    }
    49%{    fill: rgb(150, 50, 50); }
    50%{    fill: rgb(250, 150, 50); }
    99%{    fill: rgb(250, 150, 50);  }
    100%{   fill: rgb(150, 50, 50);    }
}

.vxic-rep {
  stroke: #e03535;
}

.vxic-1p7c1,.vxic-1x1c1,.vxic-1x2c1,.vxic-2x2c1,.vxic-1on6c1,.vxic-3x3c1,.vxic-4x3c3,.vxic-4x4c3,.vxic-7x7c3,.vxic-10x10c3 {
  stroke-width: 4;
  stroke: rgb(150, 50, 50);
  fill: rgb(150, 50, 50);
}
.vxic-1p7c2,.vxic-1x1c2,.vxic-1x2c2,.vxic-2x2c2,.vxic-1on6c2,.vxic-3x3c2,.vxic-4x3c2,.vxic-4x4c2,.vxic-7x7c2,.vxic-10x10c2 {
  stroke: none;
}


.vxic-ch[waiting="1"] {
    animation:blinkingChat 0.8s infinite;
}
@keyframes blinkingChat {
    0%{     stroke: white;    }
    49%{    stroke: white; }
    50%{    stroke: rgb(150, 50, 50); }
    99%{    stroke: rgb(150, 50, 50);  }
    100%{   stroke: white;    }
}

#contact_bt {
  cursor: pointer;
  font-family:'Material Icons';
  background:rgb(30,30,30);
  color:rgb(200,50,50);
  font-size:25px;
  border-radius:5px;
  padding:0px;
  width:30px;
  height:35px;
  text-align:center;
}
#contact_bt[sent=true] {
  color:rgb(50,50,50);
}

#ct_contact {
  position:relative;
  display:none;
}
#ct_contact_msg {
  font-family: "Roboto Condensed";
  font-size: 14px;
  border-color: transparent;
  border-radius:5px;
  width:90%;
}
#ct_contact_msg::placeholder {
  color: #101010;
  padding: 0 0 0 10px;
}
#ct_contact_send {
  cursor: pointer;
  position:absolute;
  font-family:'Material Icons';
  color:rgb(200,50,50);
  font-size:25px;
  padding:0px;
  width:30px;
  height:35px;
  text-align:center;
  border:none;
  background:none;
}
#ct_contact_send:active {
  color:blue;
}

.debug_cont {
 position:absolute;
 top:0;
 z-index:1;
 color:orange;
 background-color:rgba(0,0,0,0.85);
 width:100%;
}
#debug_chart {
 height:150px;
 border: 1px solid black;
}

.cap-container {
  overflow-x: hidden;
  overflow-y: overlay;
}

#audiohdr > .btn {
  cursor: default;
}

#audiohdr > .btn:hover {
  background-color: #ffc107;
  border-color: #ffc107;
}

.but_start_loc {
  position: absolute;
  z-index: 10;
  bottom: 40px;
  left: calc( 50% - 5rem );
  width: 12rem;
  max-width: 50%;
  font-size:0.75rem;
}

.btn_start_area {
  display: flex;
  justify-content: center;
  position: absolute;
  z-index: 10;
/*  left: calc( 50% - 5rem );
  width: 12rem;
  max-width: 50%; */
  width: calc(100% - 2rem);
  padding: 0;
  top: -1rem;
}
.btn_start {
  flex: 1 1 auto;
  flex-direction: row;
  width:100%;
  padding: 0.15rem 0;
  /*color:white !important;*/
  line-height: 0.9rem;
  margin: 0 0.2rem;
  font-size: 0.7rem;
  text-transform:uppercase;
  max-width: 6rem;
  border-color:#0e5e24;
  border-width:2px;
  min-height: 2rem;  
}
.enum_msg {
  position: absolute;
  top: 2rem;
  width: 100%;
  z-index: 10;
  color: red;
  font-weight: bold;
  text-align: center;
}
.btn_watch {
  background-color:white;
  color:#909020;
  border-color:#909020;
  font-weight:bold;
}
.btn_start:hover {
  border-color:#505050;
}
.btn_watch:hover {
  background-color:#909010;
}
.btn_enable_vid {
  margin-top: 3rem;
}
.controls_head {
  font-weight: bold;
  font-size: 0.7rem;
  text-transform: uppercase;
  color:#007bff;
}
.controls_head:hover {
  font-weight: bold;
  color:#007bff;
  background-color: rgba(0,120,255,0.1);
}

.sectitle {
  text-align:center;
  font-size: 0.8rem;
  font-weight: 600;
}

.thingroup {
  height:1.6rem;
}
.thinbtn {
  padding:0;
  margin:0;
  font-size:0.8rem;
}

.ctrlsec {
  border: solid #505050 2px;
  border-radius: 5px;
  padding: 2px;
  margin-top: 2px;
  margin-bottom: 5px;
}

option:checked {
  border: solid #e0c060 2px;
}

.toast-body {
  padding: 0 !important;
}

#trans-pastrooms {
  display:none;
  position:absolute;
  background: transparent;
  top: 1.6rem;
  left: 1rem;
  flex-wrap: wrap;
  padding-top: 0.5rem;
  cursor: default;
}
.ct_misc_btn_transfer {
  width:100%;
}
.ct_misc_btn_trntop:hover > #trans-pastrooms {
  display:flex;
  z-index:10;
}
.ct_misc_btn_trnf {
  font-size: 0.7rem;
}
#trans-pastrooms:hover, #trans-pastrooms:focus {
  display:flex;
  z-index:10;
}
.trans-past {
  flex: 0 0 auto;
  font-size: 0.8rem;
  font-weight: bold;
  color:#0030d0;
  background-color:white;
  border: solid 1px #0030d0;
  border-radius: 5px;
  padding: 0 0.3rem;
  margin: 0 0.1rem;
  cursor: pointer;
}
.trans-past:hover {
  color:white;
  background-color: #0030d0;
}

.ct_misc_btn_sdurl, .ct_misc_btn_sdkiosk {
  margin: 0.1rem 0.3rem;
}

.room-logo {
  position:absolute;
  top:0;
  right:0;
  max-width:25%;
  max-height:25%;
  object-fit:contain;
  border-bottom-left-radius: 10px;
}

.room-slate {
  width:100%;
  height:100%;
  object-fit:contain;
}

.pointer-name::after {
  content: attr(name);
  position: absolute;
  top: -0.5rem;
  font-size:0.7rem;
  line-height:1rem;
  left: 0.4rem;
  color: inherit;
  //background-color: rgba(0,0,0,0.5);
  //border-radius: 0.2rem;
  //padding: 0 0.2rem;
  text-shadow: 1px 1px 1px #000, 0px 0px 4px #000;
}

.kminfo {
 position:absolute;
 z-index:1001;
 top:45%;
 right:calc(50% - 10rem);
 width:20rem;
 background-color:transparent;
}

.ct_sdimage_saving {
 background-color:white;
 color: black;
 text-align:center;
 border: 2px solid black;
 border-radius: 0.4rem;
}

.ct_sdimage_restoring {
 background-color:white;
 color: black;
 text-align:center;
 border: 2px solid black;
 border-radius: 0.4rem;
}

.ct_misc_btn_sddwn0 {
 overflow: hidden;
}

#sddwn0, #sddwn1 {
 display: inline-block;
 overflow: hidden;
 max-width: calc(100% - 4rem);
 white-space: nowrap;
}

.ct_misc_btn_sddwnk0, .ct_misc_btn_sddwnk1 {
 display: inline-block;
 font-size:0.7rem;
 float: right;
 color: red;
}
.ct_misc_btn_sddwnk0:hover, .ct_misc_btn_sddwnk1:hover{
  background-color: #f09090;
  border-radius: 0.2rem;
  padding: 0 0.2rem;
}

#bigmum {
  position:absolute;
  top:calc(40% - 5rem);
  left:calc(50% - 5rem);
  font-size:10rem;
  z-index:1010;
  color:white;
  cursor: pointer;
  text-shadow: 1px 1px 1px #500, 2px 2px 1px #500, 1px -1px 1px #500, 0px 0px 4px #000;
}

.prompt_btn {
  font-size:0.8rem;
  padding: 0.1rem 0.2rem;
  text-align:center;
  width:100%;
}

.prompt_btn_mainlink {
  cursor: pointer;
  border-radius: 0.25rem;
  padding-right: 0.2rem;
  line-height: 1rem;
  margin-top: 0.5rem;
  margin-bottom: -0.5rem;
  color: #007bff;
  float:left;
}

.prompt_btn_mainlink:hover {
  background-color: rgba(0,0,0,0.1);
}

.prompt_btn_mainback {
  font-size:0.9rem;
  font-family:'Material Icons';
  content: "arrow_back_ios";
  vertical-align: middle;
}

.prompt_btn_main {
  font-size:0.7rem;
  text-transform:uppercase;
  vertical-align: middle;
  margin-left: -0.2rem;
}

.prompt_btn_main:hover {
  text-decoration: underline;
}

.prompt_head {
  text-align:center;
  line-height: 1rem;
}

.prompt_head_txt {
  font-size: 0.7rem;
  text-transform:uppercase;
  font-weight: bold;
}

.prompt_name_txt {
  font-size: 0.8rem;
  font-weight: bold;
  color: #e55500;
  text-transform:capitalize;
}

</style>
